// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"MainMenuView_topContainer__1aiCK","sectionBottom":"MainMenuView_sectionBottom__BEh_u"};